import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

interface ShowConfig extends AxiosRequestConfig {
  baseURL: string;
  method: 'GET';
  url: `/teachers/${string}/classes/${string}`;
}

/**
 * GET /vo/v1/teachers/{teacherId}/classes/{classId}
 */
export const show = (teacherId: string, classId: string): ShowConfig => {
  return {
    baseURL: BASE_API,
    method: 'GET',
    url: `/teachers/${teacherId}/classes/${classId}`,
  };
};
